import {get} from 'lodash'

export const activityOwner = () => {
  return {
    key: 'activityOwner',
    label: 'Activity Owner',
    size: 200,
    align: 'left',
    editable: false,
    dataType: 'String',
    visible: true,
    data: e => get(e, 'activityOwner', null),
  }
}